export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyCWjMj_LQp8BBHFvYMhqcdZrwoinfsSH38",
  authDomain: "mdo-staff.firebaseapp.com",
  databaseURL: "https://mdo-staff.firebaseio.com",
  projectId: "mdo-staff",
  storageBucket: "mdo-staff.appspot.com",
  messagingSenderId: "867321202993",
  appId: "1:867321202993:web:0307db1e963fc9a60b0810",
  measurementId: "G-TQSY9ZXW91"
};
export default {
  FIREBASE_CONFIG
};
